import React from 'react';

import Header from '../../../../../../components/Stake/header';
import OmBlackIcon from '../../../../../../assets/images/tokens/om-v2.svg';
import OmClosedLogo from '../../../../../../assets/images/om-closed-logo.svg';
import { useShowOnlyOmV2 } from '../../../../../../hooks/useShowOnlyOmV2';
import StakingStub from '../../../../../../components/staking-stub';

const ClosedStub = () => {
  const showOnlyOmV2 = useShowOnlyOmV2();
  const tokenTitle = showOnlyOmV2 ? 'OM' : 'OM V2';

  return (
    <>
      <Header
        icon={OmBlackIcon}
        title={`${tokenTitle}-Staking`}
        // onClickHistory={() => dispatch(omV2StakeActions.showHistory())}
      />
      <StakingStub
        icon={OmClosedLogo}
        text={`This ${tokenTitle} staking pool is now closed as we have moved to an upgraded V3 staking
          pool.`}
      />
    </>
  );
};

export default ClosedStub;
